<template>
  <div v-if="order && seats && seats.length > 0" ref="seatmap">
    <b-button @click="zoomIn">+</b-button> <b-button @click="zoomOut">-</b-button> <b-button @click="left">L</b-button> <b-button @click="right">R</b-button> {{selected.length}} | {{ tooltip }}
    <v-stage
        class="mt-5"
        ref="stage"
        :config="configKonva"
        :x="startX"
        :y="startY"
    >
      <v-layer ref="layer">
        <Seat
            v-for="item in seats"
            :key="item.id"
            :x="item.posX"
            :y="item.posY-7500"
            :seat="item"
            :order="order"
            :default-selected="selected.indexOf(item.id) >= 0"
            @selected="selSeat"
            @deselected="deselSeat"
            @hover="showTooltip"
        ></Seat>
      </v-layer>
    </v-stage>
  </div>
</template>

<script>

import Repository from "@/repositories/RepositoryFactory";
import Seat from "@/components/Seat";

const TicketRepository = Repository.get("tickets");
export default {
  name: "seat-map2",
  components: {Seat},
  props: {
    order: Object,
  },
  data: () => ({
    //info: "No tickets",
    displayMode: 0, // Category, Bändeli-Color, Gäste, Cüpli
    selected: [],
    rows: [
      //{"row": "A1", "x": 10, "y": 10, "selected": false},
    ],
    seats: [],

    startX: 0,
    startY: 0,
    configKonva: {
      width: 1300,
      height: 400,

      scaleX: 0.3,
      scaleY: 0.3,
    },
    tooltip: "",
  }),

  created() {
    this.getTickets();
    window.addEventListener('keydown', (e) => {
      if(e.key === "ArrowLeft"){
        return this.left();
      }
      if(e.key === "ArrowRight"){
        return this.right();
      }
      if(e.key === "ArrowUp"){
        return this.zoomIn();
      }
      if(e.key === "ArrowDown"){
        return this.zoomOut();
      }
    });
  },
  mounted() {
    this.selected = []
    // eslint-disable-next-line no-unused-vars
    this.order.tickets.forEach((value, index) => {
      this.selected.push(value.id);
    });
    this.$emit("change-selected", this.selected);
  },
  methods: {
    showTooltip(seat){
      let info = "";
      if(seat.owner){
        info = " - "+seat.owner
      }
      this.tooltip = seat.seat + info;
    },
    selSeat(id){
      this.selected.push(id);
      this.$emit("change-selected", this.selected);
    },
    deselSeat(id){
      this.selected.splice(this.selected.indexOf(id),1);
      this.$emit("change-selected", this.selected);
    },
    left(){
      this.startX += 80/this.configKonva.scaleX
    },
    right(){
      this.startX -= 80/this.configKonva.scaleX

    },
    zoomIn(){
      this.configKonva.scaleX += 0.05;
      this.configKonva.scaleY += 0.05;
    },
    zoomOut(){
      this.configKonva.scaleX -= 0.1;
      this.configKonva.scaleY -= 0.1;
    },
    getTickets: async function() {
      const { data } = await TicketRepository.getAll();
      this.seats = data;
    },

    groupBy(list, keyGetter) {
      const map = new Map();
      list.forEach((item) => {
        const key = keyGetter(item);
        const collection = map.get(key);
        if (!collection) {
          map.set(key, [item]);
        } else {
          collection.push(item);
        }
      });
      return map;
    },

  },
}
</script>

<style scoped>

</style>
